export default __webpack_public_path__ + "static/media/Mail_gd.a5b88a6a.svg";